const pospListFormatter = (data, dataKey) => {

  const dataSet = {};
  dataSet[dataKey] = JSON.parse(JSON.stringify(data));
  return dataSet;
};

  export default pospListFormatter;
  